// Copyright (c) 2016 Deere & Company

import FailurePanelContainer from './failure-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.pip.claim,
    downTimeCollection: state.claims.downTime,
    failureModes: state.claims.pip.failureModes,
    formValidation: state.claims.pip.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.pip.isEditable,
    isValidClaim: state.claims.pip.isValidClaim
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FailurePanelContainer);



// WEBPACK FOOTER //
// ./src/claim/pip/components/failure-panel/index.js